(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/embedded-giving/pay/components/paypal/eg.pay.components.paypal-commerce', '<div\n' + '  id="button-container-one-time"\n' + '  data-ng-show="$ctrl.showOneTime()"\n' + '  class="payment-method-select-btn__paypal-commerce"\n' + '></div>\n' + '<div\n' + '  id="button-container-recurring"\n' + '  data-ng-show="$ctrl.showRecurring()"\n' + '  class="payment-method-select-btn__paypal-commerce"\n' + '></div>\n' + '');
}]);
})();